import { InternalMessageBusChannels } from "sb-internal-msg-bus";
const messageTypeMapper = {
    sports: "sports",
    allSports: "allSports",
    favorites: "favorites",
    liveStream: "liveStream",
    dates: "dates",
    marketGroups: "marketGroups",
    personalized: "sports"
};
export class MessageSender {
    constructor(messageBus, channelPrefix) {
        this.messageBus = messageBus;
        this.channelPrefix = channelPrefix;
    }
    SendMessage(item) {
        const message = messageGenerator[item.type](item);
        const messageType = messageTypeMapper[item.type];
        const channel = `${this.channelPrefix}.${InternalMessageBusChannels.eventsFilter[messageType]}`;
        this.messageBus.emit(channel, message);
    }
}
const messageGenerator = {
    sports: (item) => ({ sportIds: [item.id] }),
    allSports: (_) => ({ sportIds: [] }),
    favorites: (_) => ({}),
    liveStream: (_) => ({}),
    dates: (item) => ({
        dateRange: {
            from: item.from,
            timeRange: item.timeRange
        }
    }),
    marketGroups: (item) => ({
        marketId: item.id,
        marketName: item.marketName,
        outrightSortingKey: item.outrightSortingKey
    }),
    personalized: (item) => ({ sportIds: item.id.split(",") })
};
//# sourceMappingURL=MessageSender.js.map